module.exports = __webpack_public_path__ + "static/media/apartment16.341b2f2e.jpg";